/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function(){
  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }
});
$('.hero-slideshow').each(function () {
    var $this = $(this);
    var $slider = $this.find('.swiper');

    var swiper = new Swiper($slider[0], {
        slidesPerView: 1,
        speed: 600,
        loop: $slider.data('loop'),
        autoplay: $slider.data('autoplay') ? {
            delay: $slider.data('delay'),
            disableOnInteraction: false
        } : false,
        navigation: {
            nextEl: $this.find('.hero-slideshow__arrow--next')[0],
            prevEl: $this.find('.hero-slideshow__arrow--prev')[0],
        },
        pagination: {
            el: $this.find('.hero-slideshow__pagination')[0],
            clickable: true
        }
    });
});

$(function () {
  if (window.footerAccordionInit) return;
  window.footerAccordionInit = true;

  var mobile = window.matchMedia('(max-width: 740px)');
  var titleSelector = '.footer .is-mobile-accordion';

  $(titleSelector).first().addClass('is-open');

  $(document)
    .off('click.footerAccordion')
    .on('click.footerAccordion', titleSelector, function (e) {
      if (!mobile.matches) return;
      e.preventDefault();

      $(this).toggleClass('is-open');
    });
});

$(function () {
  $(document).on('click', '.product-meta__collapsible-header', function () {
    var $row = $(this).closest('.product-meta__collapsible');
    var $content = $row.find('.product-meta__collapsible-content');
    var isOpen = $row.hasClass('is-open');

    $row.toggleClass('is-open', !isOpen);
    $(this).attr('aria-expanded', !isOpen);
    $content.stop(true, true).slideToggle(250);
  });
});

(function ($) {
  $(document)
    .off('click.productMetaOffers')
    .on('click.productMetaOffers', '.product-meta-offers__copy', function () {
      var $btn = $(this);
      var code = $btn.attr('data-code');

      if (!code || !navigator.clipboard) return;

      navigator.clipboard.writeText(code).then(function () {
        $btn.addClass('is-copied');
        setTimeout(function () {
          $btn.removeClass('is-copied');
        }, 2000);
      });
    });
})(jQuery);


$('body').on('click', '.mini-cart-footer-total', function() {
  $(this).toggleClass('active');
  $('.cart-payment-summary_main').slideToggle();
});

// ========================================================================
// $(function () {

//   var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
//   var updateUrl = root + 'cart/update.js';
//   var isCartPage = $('body').hasClass('template-cart');

//   // Section id for both the drawer (<cart-drawer section="...">) and the cart page (.shopify-section wrapper)
//   function getSectionId(el) {
//     var $drawer = $(el).closest('cart-drawer');
//     if ($drawer.length) return $drawer.attr('section');
//     var id = $(el).closest('.shopify-section').attr('id') || '';
//     return id ? id.replace('shopify-section-', '') : null;
//   }

//   // Applied codes from the pills (main block + popover), de-duped
//   function getAppliedCodes() {
//     var codes = [];
//     $('.applied_coupon-item').each(function () {
//       var code = ($(this).attr('data-discount-code') || '').trim();
//       if (code && codes.indexOf(code) === -1) codes.push(code);
//     });
//     return codes;
//   }

//   function sameCode(a, b) {
//     return a.toLowerCase() === b.toLowerCase();
//   }

//   function setLoading(btn, state) {
//     if (state) $(btn).attr({ disabled: 'disabled', 'aria-busy': 'true' });
//     else $(btn).removeAttr('disabled aria-busy');
//   }

//   // Message goes into the nearest .cart-offer-coupon_applied-message
//   // (input block → its own message, offer list → popover's top message)
//   function showMessage(el, text) {
//     var $scope = $(el).closest('.cart-offer-coupon_input--main');
//     if (!$scope.length) $scope = $(el).closest('.cart-cart-coupon_offer-popover-body');

//     var $msg = $scope.find('.cart-offer-coupon_applied-message').first();
//     $msg.html(`<div class="applied_code_error text--xsmall">${text}</div>`);
//     setTimeout(function () { $msg.empty(); }, 2500);
//   }

//   function openPopover() {
//     $('.cart-cart-coupon_offer-overlay').addClass('show');
//     if (isCartPage) $('html').addClass('lock-all');
//   }

//   function closePopover() {
//     $('.cart-cart-coupon_offer-overlay').removeClass('show');
//     if (isCartPage) $('html').removeClass('lock-all');
//   }

//   function dispatchRefresh(cart) {
//     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//       bubbles: true,
//       detail: { cart: cart }
//     }));
//   }

//   // Cart page can't re-render the section → reload; drawer re-renders via cart:refresh
//   function refreshCart(cart) {
//     if (isCartPage) {
//       location.reload();
//       return;
//     }
//     if (cart && cart.items) dispatchRefresh(cart);
//     else $.getJSON(root + 'cart.js', dispatchRefresh);
//   }

//   function updateDiscounts(codes, sectionId) {
//     var body = { discount: codes.join(',') };
//     if (sectionId) body.sections = [sectionId];

//     return $.ajax({
//       url: updateUrl,
//       type: 'POST',
//       contentType: 'application/json',
//       dataType: 'json',
//       data: JSON.stringify(body)
//     });
//   }

//   function applyCode(code, btn) {
//     code = (code || '').trim();
//     var applied = getAppliedCodes();
//     var sectionId = getSectionId(btn);

//     if (!code) {
//       showMessage(btn, 'Please enter a coupon code.');
//       return;
//     }

//     if (applied.some(function (c) { return sameCode(c, code); })) {
//       showMessage(btn, 'This coupon is already applied.');
//       return;
//     }

//     setLoading(btn, true);

//     updateDiscounts(applied.concat(code), sectionId)
//       .done(function (cart) {
//         var result = (cart.discount_codes || []).find(function (d) { return sameCode(d.code, code); });

//         if (!result || !result.applicable) {
//           setLoading(btn, false);
//           showMessage(btn, 'This coupon cannot be applied to your cart.');
//           updateDiscounts(applied, sectionId); // drop the invalid code from the cart
//           return;
//         }

//         closePopover();
//         refreshCart(cart);
//       })
//       .fail(function () {
//         setLoading(btn, false);
//         showMessage(btn, 'Something went wrong. Please try again.');
//       });
//   }

//   // Input → toggle apply button state
//   $(document).on('input', '.cart-offer-coupon_input-field', function () {
//     var hasValue = $(this).val().trim() !== '';
//     $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').toggleClass('active', hasValue);
//   });

//   // Enter key → apply
//   $(document).on('keydown', '.cart-offer-coupon_input-field', function (e) {
//     if (e.key !== 'Enter') return;
//     e.preventDefault();
//     $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').trigger('click');
//   });

//   // Apply typed code (main block + popover)
//   $(document).on('click', '.cart-offer-coupon_apply-button', function (e) {
//     e.preventDefault();
//     var code = $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_input-field').val();
//     applyCode(code, this);
//   });

//   // Apply offer code from popover list
//   $(document).on('click', '.coupon_offer-item_code-apply', function (e) {
//     e.preventDefault();
//     applyCode($(this).attr('coupon'), this);
//   });

//   // Remove applied code
//   $(document).on('click', '[data-removecode]', function () {
//     var btn = this;
//     var $item = $(btn).closest('.applied_coupon-item');
//     var code = ($item.attr('data-discount-code') || '').trim();
//     var remaining = getAppliedCodes().filter(function (c) { return c !== code; });

//     $item.addClass('is-loading');

//     updateDiscounts(remaining, getSectionId(btn))
//       .done(refreshCart)
//       .fail(function () {
//         $item.removeClass('is-loading');
//         showMessage(btn, 'Something went wrong. Please try again.');
//       });
//   });

//   // Popover open / close (back-arrow title, close button, backdrop)
//   $(document).on('click', '.cart-offer-coupon_header-coupon-opner', openPopover);

//   $(document).on('click', '.cart-cart-coupon_offer-popover-header_title, .cart-cart-coupon_offer-popover-close', closePopover);

//   $(document).on('click', '.cart-cart-coupon_offer-overlay', function (e) {
//     if (e.target === this) closePopover();
//   });
// });

$(function () {

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var isCartPage = $('body').hasClass('template-cart');
  var isBusy = false;

  /* ---------- Helpers ---------- */

  function sameCode(a, b) {
    return a.toLowerCase() === b.toLowerCase();
  }

  function hasCode(list, code) {
    return list.some(function (c) { return sameCode(c, code); });
  }

  // Codes currently applied (read from the coupon pills)
  function getAppliedCodes() {
    var codes = [];
    $('.applied_coupon-item').each(function () {
      var code = ($(this).attr('data-discount-code') || '').trim();
      if (code && !hasCode(codes, code)) codes.push(code);
    });
    return codes;
  }

  // Session storage helpers
  function getStore(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); }
    catch (e) { return null; }
  }

  function setStore(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); }
    catch (e) {}
  }

  // Loading state on the coupon block
  function setLoading(state) {
    $('.cart-offer-coupon').toggleClass('loading', state);
  }

  // Save new discount codes to the cart
  function updateDiscounts(codes) {
    return $.ajax({
      url: root + 'cart/update.js',
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ discount: codes.join(',') })
    });
  }

  // Cart page → reload (keep loading until reload), drawer → re-render
  function refreshCart(cart) {
    if (isCartPage) {
      location.reload();
      return;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cart }
    }));
    setLoading(false);
  }

  function showMessage(el, text) {
    var $scope = $(el).closest('.cart-offer-coupon_input--main');
    if (!$scope.length) $scope = $(el).closest('.cart-cart-coupon_offer-popover-body');

    var $msg = $scope.find('.cart-offer-coupon_applied-message').first();
    $msg.html(`<div class="applied_code_error text--xsmall">${text}</div>`);
    setTimeout(function () { $msg.empty(); }, 2500);
  }

  function openPopover() {
    $('.cart-cart-coupon_offer-overlay').addClass('show');
    if (isCartPage) $('html').addClass('lock-all');
  }

  function closePopover() {
    $('.cart-cart-coupon_offer-overlay').removeClass('show');
    if (isCartPage) $('html').removeClass('lock-all');
  }

  /* ---------- Milestone auto coupon ---------- */

  // Read milestone data from the bar
  function getMilestone() {
    var $bar = $('.shipping-notes-wrapper[data-current]').first();
    var current = Number($bar.attr('data-current')) || 0;
    var allCodes = [];
    var target = '';

    $bar.find('.check-point').each(function () {
      var code = ($(this).attr('data-coupon') || '').trim();
      var price = Number($(this).attr('data-price')) || 0;
      if (!code) return;

      allCodes.push(code);
      if (current >= price) target = code; // highest reached threshold with a coupon wins
    });

    return { current: current, allCodes: allCodes, target: target };
  }

  function syncMilestoneCoupon() {
    if (isBusy) return;

    var milestone = getMilestone();
    if (!milestone.allCodes.length) return;

    // Customer removed this code and cart value hasn't changed → leave it removed
    var removed = getStore('milestone_removed');
    if (removed && milestone.target && sameCode(removed.code, milestone.target) && removed.value === milestone.current) {
      milestone.target = '';
    }

    var applied = getAppliedCodes();

    // Keep customer's own codes, swap milestone code for the right one
    var newCodes = applied.filter(function (c) { return !hasCode(milestone.allCodes, c); });
    if (milestone.target) newCodes.push(milestone.target);

    // Nothing to change
    var oldKey = applied.map(function (c) { return c.toLowerCase(); }).sort().join();
    var newKey = newCodes.map(function (c) { return c.toLowerCase(); }).sort().join();
    if (oldKey === newKey) return;

    // Already tried this exact update at this cart value → don't loop
    var syncKey = milestone.current + '|' + newKey;
    if (getStore('milestone_last_sync') === syncKey) return;
    setStore('milestone_last_sync', syncKey);

    isBusy = true;
    setLoading(true);

    updateDiscounts(newCodes)
      .done(function (cart) {
        var isValid = !milestone.target || (cart.discount_codes || []).some(function (d) {
          return sameCode(d.code, milestone.target) && d.applicable;
        });

        if (isValid) {
          refreshCart(cart);
        } else {
          // code not usable → put old codes back
          updateDiscounts(applied).always(function () { setLoading(false); });
        }
      })
      .fail(function () { setLoading(false); })
      .always(function () { isBusy = false; });
  }

  // Run on load and after every cart re-render (drawer or cart page)
  var syncTimer;
  new MutationObserver(function () {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncMilestoneCoupon, 300);
  }).observe(document.body, { childList: true, subtree: true });

  syncMilestoneCoupon();

  /* ---------- Manual coupons ---------- */

  function applyCode(code, btn) {
    code = (code || '').trim();
    var applied = getAppliedCodes();

    if (!code) {
      showMessage(btn, 'Please enter a coupon code.');
      return;
    }

    if (hasCode(applied, code)) {
      showMessage(btn, 'This coupon is already applied.');
      return;
    }

    isBusy = true;
    setLoading(true);
    $(btn).attr('disabled', 'disabled');

    updateDiscounts(applied.concat(code))
      .done(function (cart) {
        var isValid = (cart.discount_codes || []).some(function (d) {
          return sameCode(d.code, code) && d.applicable;
        });

        if (!isValid) {
          $(btn).removeAttr('disabled');
          showMessage(btn, 'This coupon cannot be applied to your cart.');
          updateDiscounts(applied).always(function () { setLoading(false); });
          return;
        }

        closePopover();
        refreshCart(cart);
      })
      .fail(function () {
        $(btn).removeAttr('disabled');
        showMessage(btn, 'Something went wrong. Please try again.');
        setLoading(false);
      })
      .always(function () { isBusy = false; });
  }

  // Toggle apply button state
  $(document).on('input', '.cart-offer-coupon_input-field', function () {
    var hasValue = $(this).val().trim() !== '';
    $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').toggleClass('active', hasValue);
  });

  // Enter key → apply
  $(document).on('keydown', '.cart-offer-coupon_input-field', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').trigger('click');
  });

  // Apply typed code
  $(document).on('click', '.cart-offer-coupon_apply-button', function (e) {
    e.preventDefault();
    var code = $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_input-field').val();
    applyCode(code, this);
  });

  // Apply code from offer list
  $(document).on('click', '.coupon_offer-item_code-apply', function (e) {
    e.preventDefault();
    applyCode($(this).attr('coupon'), this);
  });

  // Remove applied code
  $(document).on('click', '[data-removecode]', function () {
    var btn = this;
    var $item = $(btn).closest('.applied_coupon-item');
    var code = ($item.attr('data-discount-code') || '').trim();
    var remaining = getAppliedCodes().filter(function (c) { return !sameCode(c, code); });

    // If it's a milestone code, remember it so it isn't re-applied until the cart changes
    var milestone = getMilestone();
    if (hasCode(milestone.allCodes, code)) {
      setStore('milestone_removed', { code: code, value: milestone.current });
    }

    isBusy = true;
    setLoading(true);
    $item.addClass('is-loading');

    updateDiscounts(remaining)
      .done(refreshCart)
      .fail(function () {
        $item.removeClass('is-loading');
        showMessage(btn, 'Something went wrong. Please try again.');
        setLoading(false);
      })
      .always(function () { isBusy = false; });
  });

  // Popover open / close
  $(document).on('click', '.cart-offer-coupon_header-coupon-opner', openPopover);
  $(document).on('click', '.cart-cart-coupon_offer-popover-header_title, .cart-cart-coupon_offer-popover-close', closePopover);
  $(document).on('click', '.cart-cart-coupon_offer-overlay', function (e) {
    if (e.target === this) closePopover();
  });
});
// ====================================================================
$(function () {
  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbxY_7bR-AQfE9imNYBua1Dxg5MfT0aMz5TysmAg5LKBk817GIXKETJwdkZhhUo90J6F/exec';

  $(document).on('submit', '.contact-info-form__card form', function () {
    var $form = $(this);

    var data = new URLSearchParams({
      name: $form.find('[name="contact[name]"]').val(),
      email: $form.find('[name="contact[email]"]').val(),
      phone: $form.find('[name="contact[phone]"]').val(),
      subject: $form.find('[name="contact[subject]"]').val(),
      message: $form.find('[name="contact[body]"]').val()
    });

    navigator.sendBeacon(SHEET_URL, data);
  });
});
// ====================================================================
$(function () {
  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbxY_7bR-AQfE9imNYBua1Dxg5MfT0aMz5TysmAg5LKBk817GIXKETJwdkZhhUo90J6F/exec';
  var SHEET_ID = '804109922';

  $(document).on('submit', '#wholesale-form', function () {
    var data = {};

    $(this).find('[name^="contact["]').each(function () {
      var $input = $(this);
      var key = $input.attr('name').slice(8, -1);
      var value = $input.val();

      if ($input.is(':checkbox, :radio')) {
        if (!$input.is(':checked')) return;

        if ($input.is(':checkbox')) {
          var parts = key.split(' - ');
          key = parts.shift();
          value = parts.join(' - ');
        }
      }

      data[key] = data[key] ? data[key] + ', ' + value : value;
    });

    data.sheet = SHEET_ID;

    navigator.sendBeacon(SHEET_URL, new URLSearchParams(data));
  });
});
// ============================================================================
$(function () {
  const $toolbar = $('.mobile-toolbar');
  if (!$toolbar.length) return;

  function updateSticky() {
    const scrollTop = $(window).scrollTop();

    $toolbar.each(function () {
      const $this = $(this);
      const stickyTop = parseFloat($this.css('top')) || 0;
      const viewportTop = $this.offset().top - scrollTop;
      const isSticky = scrollTop > 0 && viewportTop <= stickyTop + 1;

      $this.toggleClass('is-sticky', isSticky);
    });
  }

  $(window).on('scroll resize', updateSticky);
  updateSticky();
});